import React, { useState, useEffect } from 'react';

import './styles.css';

import { FaTimes, FaCheck } from 'react-icons/fa';

function Select(props) {
    const [status, setStatus] = useState(props.status ? props.status : (props.checkMode ? 1 : 0))

    useEffect(() => {
        setStatus(props.status)
    }, [props.status])

    function selectStatusIcon(status) {
        if (status === 1 | status === 2) return <FaCheck />
        else if (props.viewMode) return <FaTimes />
    }

    function selectStatusStyle(status) {
        if (status === -1) return 'hide'
        else if (status === 1) return 'true'
        else if (status === 2) return 'check'
        else if (props.viewMode) return 'false'
        else return ''
    }

    function changeStatus(inStatus) {
        if (inStatus === 0) setStatus(1);
        else if (inStatus === 1 && props.viewMode !== true && props.checkMode) setStatus(2);
        else if (inStatus === 2 && props.single !== true) setStatus(1);
        else if (inStatus === 1 && props.single !== true) setStatus(0);
    }

    return (
        <button
            key={props.index}
            className={"select " + (props.blocked ? "blocked " : "") + selectStatusStyle(status)}
            onClick={() => {
                if(status !== -1 && props.blocked !== true) {
                    changeStatus(status)
                    props.onClick()
                }
            }}
        >
            <div className='select-content'>
                {
                    props.devView ?
                        <>
                            <h3>Select {props.index}</h3>
                            <p>status: {status}</p>
                            <p>blocked: {props.blocked ? "true" : "false"}</p>
                        </>
                    : []
                }
                {props.children}
            </div>
            <span className={selectStatusStyle(status) + (props.single ? ' single' : '')}>
                {selectStatusIcon(status)}
            </span>
        </button>
    )
}

export default Select;